import { PerspectiveGroupingRuleWithWorkspace } from './types';
import { PerspectiveGroupingRule } from '@ardoq/perspectives';

export const isPerspectiveGroupingRuleWithWorkspace = (
  rule: PerspectiveGroupingRule
): rule is PerspectiveGroupingRuleWithWorkspace => 'workspaceId' in rule;
